import PageLayout from "@/components/feature/PageLayout";
import BackToTop from "@/components/feature/BackToTop";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SectionHeading from "@/components/feature/SectionHeading";
import ArticleCard from "@/components/feature/ArticleCard";
import usePageMeta from "@/hooks/usePageMeta";
import type { Article } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

export default function CategoryPage({
  categorySlug,
  metaTitle,
  metaDesc,
  heading,
  kicker,
  articles,
}: {
  categorySlug: string;
  metaTitle: string;
  metaDesc: string;
  heading: string;
  kicker: string;
  articles: Article[];
}) {
  usePageMeta({ title: metaTitle, description: metaDesc });

  const featured = articles[0];
  const rest = articles.slice(1);

  return (
    <PageLayout>
      <section className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: heading }]} />
        <div className="mt-6">
          <SectionHeading kicker={kicker} title={heading} />
        </div>

        {featured && (
          <a
            href={`/article/${featured.slug}`}
            className="group relative mb-6 block overflow-hidden rounded-lg"
          >
            <img
              src={featured.cover}
              alt={featured.title}
              title={`${featured.title} - 可游漫画网`}
              className="h-56 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105 md:h-80"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/50 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <span className="manga-clip mb-3 inline-block bg-accent-500 px-2.5 py-1 text-xs font-bold text-foreground-950">
                头条 · {featured.tag}
              </span>
              <h2 className="font-heading text-xl leading-snug text-background-50 md:text-2xl">{featured.title}</h2>
              <p className="mt-2 hidden max-w-3xl text-sm text-background-300 md:line-clamp-2">{featured.excerpt}</p>
              <div className="mt-3 flex items-center gap-4 text-xs text-background-400">
                <span className="flex items-center gap-1"><i className="ri-calendar-line" />{featured.date}</span>
                <span className="flex items-center gap-1"><i className="ri-eye-line" />{featured.views.toLocaleString()}</span>
              </div>
            </div>
          </a>
        )}

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map((a) => (
            <ArticleCard key={a.slug} article={a} />
          ))}
        </div>
      </section>
      <BackToTop />
    </PageLayout>
  );
}